import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconCut: React.FC<IconProps> = ({ width = 26, height = 26 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clip-path="url(#clip0_5702_14989)">
                <path
                    d="M6.07818 5.12085C6.28676 4.26835 6.03591 3.33196 5.31949 2.73066L3.9002 1.53184C2.8956 0.689065 1.39735 0.820516 0.554269 1.82496C-0.288475 2.8294 -0.154723 4.33259 0.850059 5.17533L2.27991 6.37431C2.99633 6.97546 3.96608 7.07834 4.76937 6.72492L5.59248 7.41888L7.20252 6.0678L6.07818 5.12085ZM4.59646 5.21248C4.23246 5.64634 3.5836 5.70315 3.14959 5.33915L1.72088 4.14033C1.28721 3.77633 1.2304 3.12747 1.59422 2.69361C1.95803 2.25976 2.60708 2.20328 3.04093 2.5671L4.46979 3.76608C4.90346 4.12995 4.96028 4.77897 4.59646 5.21248Z"
                    fill="black"
                    fill-opacity="0.7"
                />
                <path
                    d="M8.60498 9.95834L12.9684 13.6364C13.8544 14.3797 15.1387 14.264 15.8809 13.3783L10.216 8.60645L8.60498 9.95834Z"
                    fill="black"
                    fill-opacity="0.7"
                />
                <path
                    d="M15.9562 2.62298C15.2128 1.73728 13.8923 1.62152 13.0063 2.36486L4.77012 9.27601C3.96682 8.92242 2.99773 9.02532 2.28115 9.62663L0.85245 10.8254C-0.152149 11.6684 -0.2836 13.1714 0.559144 14.176C1.40223 15.1804 2.90526 15.3119 3.9097 14.469L5.3384 13.27C6.05498 12.6688 6.32452 11.7325 6.11592 10.8801L15.9562 2.62298ZM7.96988 7.33766C8.37184 7.33766 8.69704 7.66334 8.69704 8.06483C8.69704 8.46663 8.37186 8.79199 7.96988 8.79199C7.56839 8.79199 7.2429 8.46647 7.2429 8.06483C7.2429 7.66334 7.56841 7.33766 7.96988 7.33766ZM4.46988 12.235L3.04102 13.434C2.60717 13.798 1.95815 13.7412 1.59431 13.3075C1.23031 12.8736 1.28712 12.2247 1.72097 11.8609L3.14968 10.6619C3.58369 10.2979 4.23255 10.3548 4.59655 10.7886C4.96037 11.2221 4.90356 11.871 4.46988 12.235Z"
                    fill="black"
                    fill-opacity="0.7"
                />
                <path
                    d="M12.0365 7.83398H10.7153V8.49458H12.0365V7.83398Z"
                    fill="black"
                    fill-opacity="0.7"
                />
                <path
                    d="M14.018 7.83398H12.6968V8.49458H14.018V7.83398Z"
                    fill="black"
                    fill-opacity="0.7"
                />
                <path
                    d="M15.9999 7.83398H14.6787V8.49458H15.9999V7.83398Z"
                    fill="black"
                    fill-opacity="0.7"
                />
            </g>
            <defs>
                <clipPath id="clip0_5702_14989">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconCut;
